import './bootstrap';
import Alpine from 'alpinejs';
import 'intl-tel-input/build/css/intlTelInput.css';
import intlTelInput from 'intl-tel-input';
// Patient Category Modal Component (rdv.ardentis.ch)
import './components/patient-category-modal.js';
// Patient Cookies Banneer (rdv.ardentis.ch)
import './components/patient-cookie-banneer.js';

window.Alpine = Alpine;
Alpine.start();

window.intlTelInput = intlTelInput;



// Slots Booking Module (rdv.ardentis.ch)
import { initSlotsBooking } from './slots-booking.js';
// Exposer initSlotsBooking globalement pour utilisation depuis Blade
window.initSlotsBooking = initSlotsBooking;

